// eslint-disable-next-line import/no-dynamic-require
const config = require(`./${
  process.env.REACT_APP_ENVIRONMENT
}`).default;

export default config;
